import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-black/10 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-5 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 bg-black grid place-items-center text-white font-black">S</div>
            <span className="font-mono font-bold text-lg tracking-tight">SendMe<span className="text-[#FF3366]">.</span></span>
          </div>
          <p className="text-sm text-black/60 max-w-md leading-relaxed">
            Send any file, anywhere. Encrypted in transit, expires by default,
            shareable via a 6-digit code or QR. No signup required.
          </p>
          <p className="text-xs text-black/45 mt-4 font-mono">
            Built for fast, friction-free file transfers — used by designers, lawyers,
            photographers, and HR teams across India, the US, and Europe.
          </p>
        </div>

        <div>
          <div className="small-caps mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-[#FF3366]" to="/">Send a file</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/receive">Receive</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/teams">Teams</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/pricing">Pricing</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/dashboard">Dashboard</Link></li>
          </ul>
        </div>

        <div>
          <div className="small-caps mb-3">Resources</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-[#FF3366]" to="/blog">Blog</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/help">Help center</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/use-cases">Use cases</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/glossary">Glossary</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/security">Security</Link></li>
          </ul>
        </div>

        <div>
          <div className="small-caps mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-[#FF3366]" to="/about">About</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/contact">Contact</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/privacy">Privacy</Link></li>
            <li><Link className="hover:text-[#FF3366]" to="/terms">Terms</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-black/50">
          <span className="font-mono">© {new Date().getFullYear()} SendMe · Operated from Delhi, India</span>
          <span className="font-mono">
            <a href="mailto:hello@sendme.co.in" className="hover:text-black">hello@sendme.co.in</a>
            {" · "}
            <Link to="/privacy" className="hover:text-black">Privacy</Link>
            {" · "}
            <Link to="/terms" className="hover:text-black">Terms</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
